import { render, staticRenderFns } from "./WorkResultByFields.html?vue&type=template&id=cd38cc64&scoped=true&external"
import script from "./WorkResultByFields.ts?vue&type=script&lang=ts&external"
export * from "./WorkResultByFields.ts?vue&type=script&lang=ts&external"
import style0 from "./WorkResultByFields.css?vue&type=style&index=0&id=cd38cc64&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd38cc64",
  null
  
)

export default component.exports